import { Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ConstantsService } from '../../constants/constants.service';
import { NavigationStart, Router, RouterLink } from '@angular/router';
import { CommonModule, DatePipe } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { FormsModule } from '@angular/forms';
import { HttpService } from '../../services/http.service';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { NotificationWebsocketService } from '../../services/notification-websocket.service';
import { VisitUpdateService } from '../../services/VisitUpdateService';
import { QrScannerComponent } from '../qr-scanner/qr-scanner.component';
import { ProfileUpdateService } from '../../services/ProfileUpdateService';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    DatePipe,
    RouterLink,
    CommonModule,
    FormsModule,
    QrScannerComponent,
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class HeaderComponent implements OnInit, OnDestroy {
  notificationSub: Subscription | null = null;
  private routerSub: Subscription | null = null;

  // roleName: string = '';
  selectedRole: any = null;

  originalRole: string = '';
  roles: any = [];
  unreadCount: number = 0;
  showNotifications: boolean = false;
  notifications: any = [];
  user: any;
  currentDate: Date = new Date();
  isAdmin: boolean = false;
  openScanner = false;
  profilePhoto: any;
  userId: string = '';
  roleName: string = '';
  showRequestDetailsModal: boolean = false;
  invitationLink: string = '';
  linkCopied = false;
  formSubmitLoader2: boolean = false;
  visitInvitation: any = {
    visitPurpose: { purposeTypeId: null },
    visitLocation: { visitLocationId: null },
  };
  showSuccessModal = false;

  constructor(
    public httpService: HttpService,
    public constants: ConstantsService,
    private router: Router,
    private toastr: ToastrService,
    private notificationSocket: NotificationWebsocketService,
    private visitUpdateService: VisitUpdateService,
    private profileUpdateService: ProfileUpdateService
  ) {}

  ngOnInit() {
    setInterval(() => {
      this.currentDate = new Date();
    }, 1000);

    this.user = this.constants.getSession();
    this.originalRole = this.constants.getRoleSession();

    if (this.user) {
      // this.roleName = this.user.role?.name || '';
      this.isAdmin = this.user.isAdmin;

      // ✅ Populate role dropdown dynamically
      // this.roles = this.user.roles?.map((r: any) => r.name) || [];
      this.roles = this.user.roles || [];

      const currentRole = this.user.role;
      this.selectedRole =
        this.roles.find((r: any) => r.name === currentRole?.name) || null;
      // Notification WebSocket connection
      if (this.user && this.user.email) {
        this.notificationSocket.connect(this.user.email);

        this.notificationSub = this.notificationSocket
          .getNotifications()
          .subscribe((notification) => {
            const title = `🔔 ${notification.title}`;
            const message = notification.message;
            this.toastr.info(message, title, {
              enableHtml: true,
              timeOut: 5000,
              closeButton: true,
              positionClass: 'toast-bottom-right',
            });
            this.loadUnreadCount();
            this.notificationsList();
            this.playNotificationSound();
            this.visitUpdateService.notifyVisitUpdated();
          });
      }
    }

    // this.loadUnreadCount();
    this.notificationsList();
    if (this.user) {
      this.userId = this.user.usersId;
    }
    this.visitUpdateService.notificationCountUpdated$.subscribe(() => {
        this.loadUnreadCount();
      });
    this.routerSub = this.router.events
      .pipe(filter((event) => event instanceof NavigationStart))
      .subscribe(() => {
        this.showNotifications = false;
      });  
    this.getUserDetail(this.userId);
    this.profileUpdateService.profileUpdated$.subscribe(() => {
      if (this.userId) {
        this.getUserDetail(this.userId); //  reload user details (including photo)
      }
    });
  }

  ngOnDestroy() {
  this.notificationSub?.unsubscribe();
  this.routerSub?.unsubscribe();
  }
  logout() {
    this.constants.clearSession();
    this.router.navigate(['/dashboard']);
  }

  toggleSidebar() {
    const wrapper = document.getElementById('main-wrapper');
    if (wrapper) {
      wrapper.classList.toggle('mini-sidebar');
      wrapper.classList.toggle('show-sidebar');

      if (wrapper.classList.contains('mini-sidebar')) {
        wrapper.setAttribute('data-sidebartype', 'mini-sidebar');
      } else {
        wrapper.setAttribute('data-sidebartype', 'full');
      }
    }
  }
  closeSidebar() {
    const wrapper = document.getElementById('main-wrapper');
    if (wrapper) {
      wrapper.classList.remove('show-sidebar');
    }
  }

  playNotificationSound() {
    const audio = new Audio('assets/images/notification.mp3');
    audio.volume = 1.0; // Set volume (0.0 to 1.0)
    audio.play().catch((error) => {
      console.error('Error playing sound:', error);
    });
  }

  onRoleChange(event: any) {
  if (!this.selectedRole) return;

  const keyRole = this.selectedRole.keyRole;
  console.log('Selected role:', keyRole);

   const currentPhotoUrl = this.profilePhoto;
   this.profilePhoto = currentPhotoUrl;// keep the one from use
  
  this.httpService
    .getRequest(this.constants.SERVER_URLS['ROLE_OBJECT'] + '/' + keyRole)
    .subscribe((res: any) => {
      if (res.status === this.constants.RESPONSE_CODES['SUCCESS']) {
        const storedUser = this.constants.getSession();
        storedUser.role = res.result;
        this.constants.setSession(storedUser);
        this.constants.setRoleSession(res.result);
        this.user = storedUser;

        this.httpService
          .getRequest(
            this.constants.SERVER_URLS['SET_ACTIVE_ROLE'] + '/' + keyRole
          )
          .subscribe((tokenRes: any) => {
            if (tokenRes.status === this.constants.RESPONSE_CODES['SUCCESS']) {
              storedUser.sessionToken = tokenRes.result;
              this.constants.setSession(storedUser);

              const routeMap: { [key: string]: string } = {
                ADMIN: '/users',
                HOST: '/dashboard',
                RECEPTION: '/todays-visits',
                SECURITY: '/todays-visits',
              };

              const route = routeMap[keyRole]
                ? routeMap[keyRole]
                : this.constants.hasModulePermission('Visit', 'LIST')
                ? '/dashboard'
                : '/settings';
              
              // ✅ Navigate without hard reload
              this.router.navigate([route]).then(() => {
                // Emit event to update UI components
                this.profileUpdateService.notifyProfileUpdated();
                this.visitUpdateService.notifyVisitUpdated();
              });
            }
          });
      }
    });
}

  loadUnreadCount() {
    this.httpService
      .getRequest(this.constants.SERVER_URLS['NOTIFICATION_COUNT'])
      .subscribe((res: any) => {
        if (res.status === this.constants.RESPONSE_CODES['SUCCESS']) {
          this.unreadCount = res.result;
        }
      });
  }

  notificationsList() {
  this.httpService
    .getRequest(this.constants.SERVER_URLS['NOTIFICATION_LIST'])
    .subscribe((res: any) => {
      if (res.status === this.constants.RESPONSE_CODES['SUCCESS']) {
        this.notifications = res.result;
        if (this.unreadCount === 0) {
          this.loadUnreadCount();
        }
      }
    });
}

  toggleNotificationPanel() {
    this.showNotifications = !this.showNotifications;
    if (this.showNotifications) {
      this.notificationsList();
    }
  }

  markAllAsRead() {
    if (this.notifications && this.notifications.length > 0) {
      this.httpService
        .putRequest(this.constants.SERVER_URLS['MARK_ALL_AS_READ'], {})
        .subscribe(
          (res: any) => {
            if (res.status === this.constants.RESPONSE_CODES['SUCCESS']) {
              this.toastr.success(res.message);
              this.notificationsList();
              this.loadUnreadCount();
            } else {
              this.toastr.error('Failed to mark all notifications as read');
            }
          },
          (error: any) => {
            this.toastr.error('Error marking notifications as read');
          }
        );
    }
  }

  onNotificationClick(notification: any): void {
    if (!notification || !notification.notificationId) return;

    this.httpService
      .getRequest(
        this.constants.SERVER_URLS['NOTIFICATION'] +
          '/' +
          notification.notificationId
      )
      .subscribe(
        (res: any) => {
          if (res.status === this.constants.RESPONSE_CODES['SUCCESS']) {
            this.showNotifications = false;
            this.loadUnreadCount();
            this.notificationsList();
            switch (notification.type) {
            case 'Visit_Submission':
              this.router.navigate(['/visit-list'], {
                queryParams: { status: 'Pending_Approvals' },
              });
              break;
            case 'Request_For_Approval':
            this.router.navigate(['/approval-requests']);
            break;
            case 'Visit_Reschedule_Request':
              this.router.navigate(['/visit-list'], {
                queryParams: { status: 'Pending_Approvals' },
              });
              break;
              case 'Visit_Cancellation_Request':
              this.router.navigate(['/visit-list'], {
                queryParams: { status: 'Pending_Approvals' },
              });
              break;  
            default:
              this.router.navigate(['/notifications']);
          }
          } else {
            this.toastr.error('Failed to update notification status');
          }
        },
        (error) => {
          this.toastr.error('Error marking notification as read');
        }
      );
  }
  viewAllNotifications() {
    this.showNotifications = false;
    this.router.navigate(['/notifications']);
  }

  handleScan(event: any) {
    const result = event?.detail?.result;
    if (result) {
      console.log('Scanned from header:', result);
    }
    this.openScanner = false;
  }
  getUserDetail(userId: any) {
    this.httpService
      .getRequest(this.constants.SERVER_URLS['USER_DETAILS'] + userId)
      .subscribe((res: any) => {
        if (res.status === this.constants.RESPONSE_CODES['SUCCESS']) {
          this.user = res.result;
           this.profilePhoto = this.resolveProfilePhoto(this.user?.photo);
        } else {
          this.toastr.error(res.message,  );
        }
      });
  }
  @HostListener('document:click', ['$event'])
onDocumentClick(event: MouseEvent): void {
  if (!this.showNotifications) return;
  const target = event.target as HTMLElement;
  const clickedInsidePanel = target.closest('.notification-panel');
  const clickedNotificationTrigger = target.closest('[data-notification-trigger]');
  if (!clickedInsidePanel && !clickedNotificationTrigger) {
    this.showNotifications = false;
  }
}
  @ViewChild('roleDropdown') roleDropdown!: ElementRef<HTMLSelectElement>;

  openRoleDropdown() {
    console.log('Opening role dropdown');
    if (this.roleDropdown && this.roleDropdown.nativeElement) {
      this.roleDropdown.nativeElement.click();
    }
  }

// GTH-860: Send visit invite via WhatsApp, Email, or Copy Link | By Priya K, 07.08.2025

  shareVia(method: 'whatsapp' | 'sms' | 'email') {
  // ✅ Create fresh payload without ID
  const requestPayload = {
    visitPurpose: { purposeTypeId: null },
    visitLocation: { visitLocationId: null }
  };

  this.httpService
    .postRequest(
      this.constants.SERVER_URLS['GENERATE_INVITATION_LINK'],
      requestPayload
    )
    .subscribe(
      (res) => {
        if (res.status === this.constants.RESPONSE_CODES['SUCCESS']) {
          const generatedLink = res.result.link;
          // Only store the ID when needed for email flow
          if (method === 'email') {
            this.visitInvitation.visitInvitationId = res.result.visitInvitationId;
          }

          const message = `Hi, please complete your visit details here: ${generatedLink} - Visitor Bridge`;

          switch (method) {
            case 'whatsapp':
              const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(message)}`;
              window.open(whatsappUrl, '_blank');
              break;

            case 'email':
              this.showRequestDetailsModal = true;
              break;
          }
        } else {
          this.toastr.error(res.message);
        }
      },
      () => {
        this.toastr.error('Failed to generate link.',  );
      }
    );
}

  copyLink() {
  // ✅ Reset visitInvitationId before generating a new link
  const requestPayload = {
    visitPurpose: { purposeTypeId: null },
    visitLocation: { visitLocationId: null }
  };

  this.httpService
    .postRequest(
      this.constants.SERVER_URLS['GENERATE_INVITATION_LINK'],
      requestPayload
    )
    .subscribe(
      (res) => {
        if (res.status === this.constants.RESPONSE_CODES['SUCCESS']) {
          const generatedLink = res.result.link;
          const message = `Hi, please complete your visit details here: ${generatedLink} - Visitor Bridge`;
          
          if (navigator.clipboard && navigator.clipboard.writeText) {
              navigator.clipboard
                .writeText(message)
                .then(() => {
                  this.linkCopied = true;
                  this.toastr.success('Link copied successfully!', 'Copied');
                  setTimeout(() => {
                    this.linkCopied = false;
                  }, 2000);
                })
                .catch(() => {
                  
                  this.fallbackCopyTextToClipboard(message);
                });
            } else {
             
              this.fallbackCopyTextToClipboard(message);
            }
        } else {
          this.toastr.error(res.message);
        }
      },
      () => {
        this.toastr.error('Failed to generate link.',  );
      }
    );
}
private fallbackCopyTextToClipboard(text: string) {
    const el = document.createElement('div');
    el.contentEditable = 'true';
    el.innerText = text;
    el.style.position = 'fixed';
    el.style.left = '-999999px';
    el.style.top = '-999999px';
    el.style.opacity = '0';
    document.body.appendChild(el);
    setTimeout(() => {
      el.focus();
      const range = document.createRange();
      range.selectNodeContents(el);
      const selection = window.getSelection();
      if (selection) {
        selection.removeAllRanges();
        selection.addRange(range);
      }
      try {
        const successful = document.execCommand('copy');
        if (successful) {
          this.linkCopied = true;
          this.toastr.success('Link copied successfully!', 'Copied');
          setTimeout(() => {
            this.linkCopied = false;
          }, 2000);
        } else {
          this.toastr.error('Failed to copy the link.',  );
        }
      } catch (err) {
        this.toastr.error('Failed to copy the link.',  );
      }
      document.body.removeChild(el);
    }, 100);
  }

  proceedToRequestDetails() {
    this.showRequestDetailsModal = true;
  }

  closeRequestDetailsModal() {
    this.visitInvitation = {
      visitPurpose: { purposeTypeId: null },
      visitLocation: { visitLocationId: null },
    };
    this.showRequestDetailsModal = false;
  }

  requestDetails() {
    this.formSubmitLoader2 = true;

    this.httpService
      .postRequest(
        this.constants.SERVER_URLS['GENERATE_INVITATION_LINK'],
        this.visitInvitation
      )
      .subscribe(
        (res) => {
          if (res.status === this.constants.RESPONSE_CODES['SUCCESS']) {
            const generatedLink = res.result.link;
            this.visitInvitation.visitInvitationId =
              res.result.visitInvitationId;

            const invitationData = {
              visitInvitationId: this.visitInvitation.visitInvitationId,
              receiverEmail: this.visitInvitation.receiverEmail,
              link: generatedLink,
            };

            this.httpService
              .postRequest(
                this.constants.SERVER_URLS['SEND_INVITATION'],
                invitationData
              )
              .subscribe(
                (sendRes: any) => {
                  this.formSubmitLoader2 = false;
                  if (
                    sendRes.status === this.constants.RESPONSE_CODES['SUCCESS']
                  ) {
                    this.closeRequestDetailsModal();
                    this.toastr.success(sendRes.message);
                  } else {
                    this.toastr.error(sendRes.message,  );
                  }
                },
                () => {
                  this.formSubmitLoader2 = false;
                  this.toastr.error('Failed to send invitation.',  );
                }
              );
          } else {
            this.formSubmitLoader2 = false;
            this.toastr.error(res.message);
          }
        },
        () => {
          this.formSubmitLoader2 = false;
          this.toastr.error('Failed to generate link.',  );
        }
      );
  }
    private resolveProfilePhoto(photoPath: string | null | undefined): string {
    if (!photoPath) return this.constants.DEFAULT_PROFILE_PHOTO; // centralized default path

    if (photoPath.startsWith('http')) {
      return photoPath;
    }

    return this.constants.getImageUrl(photoPath);
  }

  isReceptionOrSecurity(role: any): boolean {
   const roleName = role?.name?.toLowerCase();
   return roleName === 'reception' || roleName === 'security';
  }
}